import { render, staticRenderFns } from "./MainBookCreate.vue?vue&type=template&id=6b0c35e6"
import script from "./MainBookCreate.vue?vue&type=script&lang=js"
export * from "./MainBookCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports